export default __webpack_public_path__ + "static/media/NotificationActive.1c507299.svg";